<template>
  <div>
    <!-- 请假状态 -->
    <van-nav-bar @click-right="onClickRight">
      <template #left>
        <div style="color: #333">请假审批状态</div>
      </template>
      <template #right>
        <div style="color: #646566">
          {{ selectText }}
          <van-icon name="arrow" color="#646566" />
        </div>
      </template>
    </van-nav-bar>

    <!-- 审批状态选择弹窗  -->
    <van-action-sheet v-model="show" :actions="actions" cancel-text="取消" @select="onSelect" />
    <div class="leave-list-wrap">
      <van-list v-model="loading" ref="list" v-if="list.length > 0" class="leave-list" :error.sync="error" error-text="请求失败，点击重新加载" @load="onLoad">
        <div class="leave-list-item" v-for="(item, index) in list" :key="index" @click="clickLeaveDetail(item)">
          <div class="cause flex flex-b flex-vc">
            <div class="cause_div">
              <el-checkbox v-model="item.isCheck" class="cause_check" @click.stop.native="() => {}" @change="SelectChange(index)" v-if="(item.auditState == 0 || (item.leaveState == -2 && getISAudit(item))) && item.canYouApprove == 1" />
              <span>{{ item.leaveName }} {{ item.leaveType }}{{ renderTime(item.leaveTime, item.workTime) }}</span>
            </div>

            <!-- <span
              class="status"
              v-if="item.leaveState == 0"
              @click.stop="changStatus(item)"
              >同意申请</span
            >
            <span class="status" v-if="item.leaveState == 1">已同意</span>
            <span class="status" v-if="item.leaveState == -1">已拒绝</span> -->

            <van-tag style="flex-shrink: 0;" plain type="success" @click.stop="changStatus(item)" v-if="item.auditState == 1 && (item.leaveState == 1 || item.leaveState == 0)" size="medium">已通过</van-tag>
            <van-tag style="flex-shrink: 0;" plain type="primary" size="medium" v-if="item.auditState == 0 && item.leaveState == 0">待审批</van-tag>
            <van-tag style="flex-shrink: 0;" plain type="danger" size="medium" v-if="item.leaveState == -1">已驳回</van-tag>
            <van-tag style="flex-shrink: 0;" plain type="danger" size="medium" v-if="item.leaveState == -2">已过期</van-tag>
            <van-tag style="flex-shrink: 0;" plain type="danger" size="medium" v-if="item.leaveState == -3">已作废</van-tag>
          </div>
          <div class="date">
            <span>请假开始时间：</span>
            <span>{{ getDateYMD(item.leaveBeginTime) }}</span>
          </div>
          <div class="date">
            <span>请假结束时间：</span>
            <span>{{ getDateYMD(item.leaveEndTime) }}</span>
          </div>
          <div class="date">
            <span class="text">请假原因：</span>
            <span>{{ item.remark }}</span>
          </div>
          <!-- <div class="date" v-if="item.eventType !== 2">
            <span class="text">请假类型：</span>
            <span>{{ item.eventType === 0 ? '请假离校' : item.eventType === 1 ? '请假归寝' : '' }}</span>
          </div> -->
          <div class="note">
            <div>
              <span class="text">申请时间：</span>
              <span>{{ getDateYMD(item.createdTime) }}</span>
            </div>

            <!-- 作废按钮  -->
            <div
              @click.stop="toVoid(item)"
              v-if="
                item.leaveState == 1 && item.cancelLeaveState == 0 && isShowToVoid(item) && isDuringDate(item.leaveEndTime) && item.canBeCancelled == 1 //  canBeCancelled  0能作废 1不能作废
              "
              class="flex flex-vc report"
            >
              <van-icon name="delete-o" style="margin-right: 0.3rem" />
              作废
            </div>
          </div>
        </div>
      </van-list>

      <div class="" v-else>
        <van-empty description="暂无数据" />
      </div>

      <!-- 全选 -->
      <div class="sendBox" v-if="list.some(x => (x.auditState == 0 || (x.leaveState == -2 && getISAudit(x))) && x.canYouApprove == 1)">
        <div class="allState">
          <el-checkbox v-model="selectAllState" @change="allChange()" />
        </div>
        <div class="allSelect">全选</div>
        <span></span>
        <div class="selectMsg">( 选中 {{ selectAll.length }} 条待审批项 )</div>
        <div class="Btn">
          <button class="rejectAll" @click="submitNo">
            <span>驳回</span>
          </button>
          <button class="resolveAll" @click="submit">
            <span>通过</span>
          </button>
        </div>
      </div>

      <!-- 选择审批人弹窗  -->
      <van-dialog v-model="dialogShow" show-cancel-button close-on-click-overlay confirm-button-text="通过" title="是否审批通过?" @confirm="confirmApply()">
        <div class="dialog-wrap">
          <!-- <div style="text-align: center"></div> -->
        </div>
      </van-dialog>

      <Interviewee ref="interviewee" @selectItem="handleSelIntervieweeItem" pageType="student" />
    </div>
  </div>
</template>

<script>
import { compare, getDateYMD, timeFormart } from '@/utils';
import moment from 'moment';
import Interviewee from '@/components/subScribePopup/interviewee';
export default {
  data() {
    return {
      list: [],
      radio: '1',
      show: false,
      auditRemark: '',
      item: {},
      // 当前选中的数组
      selectAll: [],
      selectAllState: false,
      dialogShow: false,
      pickerItem: {},
      error: false,
      // 作废原因
      cancelLeaveInfo: '',
      // 审批状态选择弹窗
      show: false,
      // 请假状态集合
      actions: [
        {
          name: '全部'
        },
        {
          name: '待审批'
        },
        {
          name: '已通过'
        },
        {
          name: '已驳回'
        },
        {
          name: '已过期'
        },
        {
          name: '抄送我'
        }
      ],
      // 选中的状态
      selectText: '全部',
      // 当前请假总页数
      totalPageNum: '',
      // 当前请假页数
      pageNum: 1,
      // 控制滚动
      loading: false,
      finished: false
    };
  },
  components: {
    Interviewee
  },

  async mounted() {
    // 获取当前所有的待审批列表
    const { data, code } = await this.$https.getApproveLeaveList({
      leaveState: 0,
      userId: this.$store.state.userId,
      schoolId: this.$store.state.schoolId,
      pageSize: 10,
      pageNum: 1
    });

    // 获取到待审批信息
    if (code == 200) {
      console.log('待审批信息', data);
      this.$store.commit('setTabBadge', {
        type: 'leave',
        value: data.totalNum
      });
    }

    this.getleaveList();
  },

  methods: {
    // 点击显示选择状态
    onClickRight() {
      this.show = true;
    },
    // 选择请假状态后
    async onSelect(item) {
      this.error = false;
      console.log('选择请假状态');
      if (this.$refs.list) {
        this.$refs.list.finished = false;
      }

      // this.$refs.list.finished = false
      this.finished = false;

      this.pageNum = 1;

      // 获取组件实例
      if (this.$refs.list) {
        this.$refs.list.finished = false;
      }

      let obj = {
        待审批: 0,
        已通过: 1,
        已驳回: -1,
        已过期: -2,
        全部: -11
      };

      this.show = false;
      // 获取请假列表
      let leaveList = item.name == '抄送我' ? await this.getCCTypeList(1) : await this.getApprovalList(obj[item.name], 1);
      // 设置请假列表
      this.totalPageNum = leaveList.totalPage;

      if (leaveList.list) {
        this.list = leaveList.list;
      }
      this.selectText = item.name;
    },

    // 滚动加载方法
    async onLoad() {
      console.log('---------------------------');
      // 判断是否还有新的数据
      let obj = {
        待审批: 0,
        已通过: 1,
        已驳回: -1,
        已过期: -2,
        全部: -11
      };

      if (this.pageNum == this.totalPageNum) {
        // 数据加载完毕
        this.finished = true;
      } else if (this.loading && this.pageNum !== this.totalPageNum) {
        this.finished = false;
        // 获取下一页数据
        let newList = this.selectText == '抄送我' ? await this.getCCTypeList(this.pageNum + 1) : await this.getApprovalList(obj[this.selectText], this.pageNum + 1);
        console.log('获取到下一页数据', newList, this.pageNum);

        if (!newList) {
          this.error = true;
          this.loading = false;
          return;
        }

        this.list = [...this.list, ...newList.list];
        this.pageNum = this.pageNum + 1;
        this.totalPageNum = newList.totalPage;
        this.loading = false;
      }
    },

    getDateYMD,
    duration(b, e) {
      var m1 = moment(b),
        m2 = moment(e);
      var du = moment.duration(m2 - m1, 'ms'),
        day = du.get('days'),
        hours = du.get('hours'),
        mins = du.get('minutes'),
        ss = du.get('seconds');
      const duration = day + '天' + hours + '时' + mins + '分' + ss + '秒';
      return duration;
      // this.$set(this.form, 'visitorIdCrde', duration)
    },
    changStatus(item) {
      this.show = true;
      this.item = item;
    },
    // 判断是否为审批状态
    getISAudit(data) {
      // if (data.leaveApprovalAudit.some(x => x.auditId == this.$store.state.userId && (x.auditState == 0 || x.auditState == -2))) {
      if (data.auditState == 0 || data.auditState == -2) {
        return true;
      } else {
        return false;
      }
    },

    isDuringDate(e) {
      if (moment().isBefore(e)) {
        return true;
      }
      return false;
    },

    // 判断是否展示作废请假按钮
    isShowToVoid(item) {
      // 判断是否是已审批状态
      if (
        item.leaveState == 1 &&
        // !item.leaveApprovalAudit.some((x) => x.auditState != 1)
        item.auditState == 1
      ) {
        return true;
      } else {
        return false;
      }
    },
    handleSelIntervieweeItem(item) {
      this.pickerItem = item;
    },

    // 作废当前记录
    toVoid(item) {
      // 作废当前请假记录
      this.$dialog
        .confirm({
          title: '温馨提示',
          message: '是否作废该条请假？'
        })
        .then(() => {
          this.toVoidConfirm(item);
        })
        .catch(() => {});
    },

    async toVoidConfirm(item) {
      const { code, data, msg } = await this.$https.toVoidLeave({
        userId: this.$store.state.userId,
        leaveIds: [item.id],
        cancelLeaveInfo: this.cancelLeaveInfo
      });

      if (code == 200) {
        console.log('data', data);
        this.$toast('操作完成');
        this.getleaveList2();
        return;
      } else {
        this.$toast(msg);
      }
    },

    // 获取到当前的请假记录

    getleaveList() {
      Promise.all([this.getApproveLeaveList(-11)]).then(res => {
        console.log('获取到信息', res);

        // 设置总页数和当前页数
        this.totalPageNum = res[0].totalPage;
        this.pageNum = 1;
        res.forEach(item => {
          item.list.forEach(v => {
            v.state = this.getStatus(v.leaveState);
            v.du = this.duration(v.leaveBeginTime, v.leaveEndTime);
            v.isCheck = false;
            this.list.push(v);
          });
        });
      });
    },

    getleaveList2() {
      // 获取到待审批的数据
      let obj = {
        待审批: 0,
        已通过: 1,
        已驳回: -1,
        已过期: -2,
        全部: -11
      };
      this.error = false;
      this.finished = false;
      this.loading = false;
      this.pageNum = 1;

      // this.$store.commit("setTabBadge", {
      //   type: "leave",
      //   value: res[0].list.length,
      // });

      Promise.all([this.getApprovalList(obj[this.selectText], 1)]).then(res => {
        this.list = [];
        // 设置总页数和当前页数
        this.pageNum = 1;
        this.totalPageNum = res[0].totalPage;
        res.forEach(item => {
          item.list.forEach(v => {
            v.state = this.getStatus(v.leaveState);
            v.du = this.duration(v.leaveBeginTime, v.leaveEndTime);
            v.isCheck = false;
            this.list.push(v);
          });
        });
      });
    },

    // 选中
    SelectChange(index) {
      if (this.list[index].isCheck) {
        // 添加到目标数组
        this.selectAll.push(this.list[index].id);
        this.selectAll = [...new Set([...this.selectAll])];
        let num = 0;

        this.list.forEach(item => {
          if (item.leaveState == 0 || item.leaveState == -2) {
            num += 1;
          }
        });
        if (this.selectAll.length == num) {
          this.selectAllState = true;
        }
      } else {
        this.selectAllState = false;
        this.selectAll = this.selectAll.filter(x => x != this.list[index].approvalId);
      }
    },

    // 驳回请假申请
    submitNo() {
      console.log('选中的记录条数', this.selectAll);
      if (this.selectAll.length) {
        this.$dialog
          .confirm({
            title: '温馨提示',
            message: '是否驳回审批？'
          })
          .then(() => {
            this.onConfirm();
          })
          .catch(() => {});
      } else {
        this.$toast('至少选中一项请假申请记录');
      }
      return;
    },

    // 通过请假申请
    submit() {
      if (this.selectAll.length) {
        this.dialogShow = true;
      } else {
        this.$toast('至少选中一项请假申请记录');
      }
    },

    // 全选
    allChange() {
      if (this.selectAllState) {
        let arr = [];
        this.list.forEach(item => {
          if ((item.auditState == 0 || (item.leaveState == -2 && this.getISAudit(item))) && item.canYouApprove == 1) {
            item.isCheck = true;
            arr.push(item.id);
          }
        });
        this.selectAllState = true;
        this.selectAll = arr;
      } else {
        this.selectAllState = false;
        this.selectAll = [];
        this.list.forEach(item => {
          if ((item.auditState == 0 || (item.leaveState == -2 && this.getISAudit(item))) && item.canYouApprove == 1) {
            item.isCheck = false;
          }
        });
      }
    },

    // 审批驳回
    async onConfirm() {
      console.log('this.$store.state', this.$store.state);

      // 拼凑
      let arr = [];
      this.list.forEach(item => {
        if (this.selectAll.some(x => x == item.id)) {
          arr.push({
            leaveIds: item.id,
            approvalId: item.approvalId
          });
        }
      });
      const { code, data } = await this.$https.batchApproveLeave({
        userId: this.$store.state.userId,
        // leaveIds: this.selectAll,
        idDTOList: arr,
        leaveState: -1
      });
      if (code !== 200) {
        this.$toast('审批失败，请重试');
        return;
      }
      this.$toast('驳回成功');
      this.selectAll = [];
      this.selectAllState = false;
      this.pickerItem = {};
      this.getleaveList2();
    },

    // 审批通过
    async confirmApply() {
      console.log('this.list', this.list);
      // 拼凑
      let arr = [];
      this.list.forEach(item => {
        if (this.selectAll.some(x => x == item.id)) {
          arr.push({
            leaveIds: item.id,
            approvalId: item.approvalId
          });
        }
      });
      console.log('获取批量审核的数据', arr);
      // return

      const { code, msg, data } = await this.$https.batchApproveLeave({
        userId: this.$store.state.userId,
        // leaveIds: this.selectAll,
        idDTOList: arr,
        leaveState: 1,
        auditName: this.pickerItem.name ? this.pickerItem.name + '-' + this.pickerItem.deptName : '',
        auditId: this.pickerItem.id
      });

      if (code != 200) {
        this.$toast(msg);
        return;
      }
      this.$toast('审批成功');
      this.selectAll = [];
      this.selectAllState = false;
      this.pickerItem = {};
      this.getleaveList2();
    },

    clickLeaveDetail(item) {
      this.item = item;
      console.log('获取页面跳转参数', {
        path: '/leavedetail',
        query: { type: 'au', id: item.id, approvalId: item.approvalId }
      });
      // return
      this.$router.push({
        path: '/leavedetail',
        query: { type: 'au', id: item.id, approvalId: item.approvalId }
      });
    },
    getStatus(state) {
      let map = {
        0: '待审批',
        1: '已同意',
        '-1': '已拒绝'
      };
      return map[state];
    },

    async getApproveLeaveList(state) {
      const { data, code } = await this.$https.getApproveLeaveList({
        leaveState: state,
        userId: this.$store.state.userId,
        schoolId: this.$store.state.schoolId,
        pageSize: 10,
        pageNum: 1
      });
      if (code !== 200) {
        return false;
      }
      return Promise.resolve(data);
    },

    renderTime(leaveTime, workTime) {
      let StatusMinute = '';
      var day = parseInt(leaveTime / workTime);
      var hour = parseInt((leaveTime % workTime) / 60); // 小时
      var min = parseInt((leaveTime % workTime) % 60); // 分钟
      if (day > 0) {
        StatusMinute = day + '天';
      }
      if (hour > 0) {
        StatusMinute += hour + '小时';
      }
      if (min > 0) {
        StatusMinute += parseFloat(min) + '分钟';
      }
      return `${StatusMinute || '0分钟'}`;
    },

    // 添加分页之后的查询方法
    async getApprovalList(state, pageNum) {
      console.log('进来了');
      const { data, code } = await this.$https.getApproveLeaveList({
        leaveState: state,
        userId: this.$store.state.userId,
        schoolId: this.$store.state.schoolId,
        pageSize: 10,
        pageNum
      });
      if (code != 200) {
        return false;
      }
      return data;
    },

    // 抄送我的请假类型调取接口
    async getCCTypeList(pageNum) {
      console.log('进来了获取抄送我请假类型');
      const { data, code } = await this.$https.getCcMakeList({
        userId: this.$store.state.userId,
        schoolId: this.$store.state.schoolId,
        pageSize: 10,
        pageNum
      });
      if (code != 200) {
        return false;
      }
      return data;
    }
  }
};
</script>

<style lang="scss" scoped>
.dialog-wrap {
  padding: 20px;
  .cell-wrap {
    background: #80b8f3;
    padding: 5px 15px;
    border-radius: 10px;
    height: 38px;
    border: none;
    width: 100%;
  }
}
.leave-list-wrap {
  position: relative;
  .leave-list-title {
    color: #78849e;
    font-size: 0.75rem;
    margin: 1rem;
  }
  .leave-list {
    border-radius: 0.75rem;
    border-radius: 1.0625rem;
    margin: 1rem 1rem 18vw 1rem;
    box-shadow: 0rem 1rem 1rem rgba(69, 91, 99, 0.1);
    overflow: hidden;
    .leave-list-item {
      display: flex;
      flex-direction: column;
      padding: 0.75rem;
      position: relative;
      background: #fff;
      font-size: 0.75rem;
      color: rgba(120, 132, 158, 1);
      border-bottom: 1px solid #f4f4f6;

      .check_div {
        position: absolute;
        bottom: 0.55rem;
        right: 0.55rem;
        // background-color: red;
      }
      .cause {
        font-size: 1rem;
        font-weight: bold;
        color: #333;
        margin-bottom: 0.55rem;
        .cause_div {
          display: flex;
          align-items: center;
          // width: 80%;
          .cause_check {
            margin-right: 5px;
          }
        }
        .status {
          color: #1989fa;
          font-size: 0.85rem;
        }
      }

      .date {
        margin-bottom: 0.55rem;
        // background-color: red;
        .text {
          display: inline-block;
          padding-left: 1.5rem;
        }
      }
      .note {
        display: flex;
        align-items: center;
        // background-color: red;
        .text {
          display: inline-block;
          padding-left: 1.5rem;
        }
        justify-content: space-between;
        .report {
          font-size: 1rem;
        }
      }
    }
  }
  .select_all {
    position: absolute;
    bottom: 0;
    height: 13vw;
    left: 0;
    right: 0;
    background-color: red;
  }
  .sendBox {
    display: flex;
    justify-content: left;
    align-items: center;
    height: 13vw;
    width: 100%;
    box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.1);
    position: fixed;
    bottom: 0;
    left: 0;
    padding-left: 7vw;
    background: white;
    z-index: 10;
    .allSelect {
      margin-left: 2vw;
      font-size: 4.5vw;
      transform: scale(0.9);
    }
    .selectMsg {
      font-size: 3.5vw;
      transform: scale(0.8) translate(-4vw, 0);
      color: rgb(112, 180, 250);
    }
    .Btn {
      position: absolute;
      right: 5vw;
      button {
        border: none;
        width: 16vw;
        height: 7vw;
        border-radius: 7vw;
        padding: 0;
      }
      span {
        font-size: 4vw;
        display: inline-block;
        transform: scale(0.8);
        color: rgba(255, 255, 255, 0.8);
      }
      .rejectAll {
        background: rgb(230, 123, 41);
        margin-right: 2vw;
      }
      .resolveAll {
        background: rgb(26, 136, 249);
      }
    }
  }
}

.dialog-wrap {
  padding: 10px;
}
.dialog-item-title {
  color: #78849e;
  font-size: 16px;
  margin: 10px 0;
  .dialog-item-title-tip {
    color: #ee0a24;
  }
}
.cell-wrap {
  background: #f7f7fa;
  padding: 10px 15px;
  border-radius: 20px;
  height: 38px;
  position: relative;
  .cell_wrap_cross {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
  }
  .cell_wrap_text {
    color: #fff;
    font-size: 16px;
    line-height: 30px;
    margin: 10px 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 1;
  }
}
</style>
